module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/th-2bc4f7e68d0074eb803d279b33342384.jpg";